import React from 'react'

import useDeviceDetails from 'hooks/useDeviceDetails'
import Spinner from 'components/Spinner'
import styled from 'styled-components'
import ColumnGridPanel from 'components/ColumnGridPanel'
import { screenSize } from 'styles/shared'

type Props = {
  deviceId: string
}

const DeviceDetails = ({ deviceId }: Props) => {
  const { deviceDetails, deviceMetadataDetails, areDeviceDetailsLoaded } = useDeviceDetails(deviceId)

  if (!areDeviceDetailsLoaded) {
    return <Spinner variant="page" />
  }

  return (
    <S.Form>
      <S.DetailColumn>
        <h3>DEVICES TABLE</h3>

        {deviceDetails?.map(deviceDetails => (
          <S.ColumnItem key={deviceDetails.column} label={deviceDetails.column} value={deviceDetails.value} />
        ))}
      </S.DetailColumn>

      <S.DetailColumn>
        <h3>METADATA TABLE</h3>

        {deviceMetadataDetails?.map(deviceMetadataDetails => (
          <S.ColumnItem key={deviceMetadataDetails.column} label={deviceMetadataDetails.column} value={deviceMetadataDetails.value} />
        ))}
      </S.DetailColumn>
    </S.Form>
  )
}

export default DeviceDetails

const S = {
  Form: styled.form`
    display: flex;
    padding: 40px 20px;
    grid-column-gap: 50px;
    flex-wrap: wrap;
    justify-content: space-between;
  `,
  DetailColumn: styled.div`
    flex: 1;
    padding: 20px;

    @media ${screenSize.mediumOnly} {
      flex: 1 1 30%;
    }
    @media ${screenSize.small} {
      flex: 1 1 100%;
    }
    
  `,
  ColumnItem: styled(ColumnGridPanel.Column.Item)`
    grid-template-columns: 40% 60%;

    @media ${screenSize.medium} {
      grid-template-columns: 60% 40%;
    }
  `
}
